/**
 * Created by rak on 7/26/2018.
 */
'use strict';
angular.module('betosyswebapp').directive('tachoEventGraphic', function ($parse, $window, commonTrackService, $translate) {
  return {
    restrict: 'EA',
    link: function (scope, element) {
      var d3 = $window.d3;
      // var rawSvg = element.find('svg');
      // var svg = d3.select(rawSvg[0]);
      // X axix properties time format , and  other necessary values
      var xAxis, yScale, xScale;
      var isWidgetUnderDialog = element.parents('.modal-body').length || 0;

      var margin = {
          top: 10,
          right: 10,
          bottom: 25,
          left: isWidgetUnderDialog ? 80 : 10
        },
        width = isWidgetUnderDialog ? 1500 : 600,
        height = 300;

      //var paddingWidthDiffernce = isWidgetUnderDialog ? 4 : 2;


      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var todayMillis = today.getTime();
      var initialData = [{
        'tachoeventbegin': new Date(),
        'tachoeventend': new Date(),
        'tachoeventduration': 0,
        'workingState': '',
        'driverworkinstatevalue': 0
      }];

      scope.chartInitialData = initialData;


      var tachoDetailWidgtEvet = scope.$on('tacho_event_history_init_graphic', function (event, data) {
        if (data.eventType === 'tacho_event_history_table_row_select') {
          redrawChart(initialData);
          scope.chartInitialData = [];

          if (data.dataList.length > 0) {

            scope.chartInitialData = data.dataList;

            if (typeof scope.chartInitialData[0].tachoeventbegin === 'string') {
              scope.chartInitialData.forEach(function (d) {
                var parts = d.tachoeventbegin.split(/:/);
                var timePeriodMillis = (parseInt(parts[0], 10) * 60 * 60 * 1000) +
                  (parseInt(parts[1], 10) * 60 * 1000);
                d.tachoeventbegin = new Date();
                d.tachoeventbegin.setTime(todayMillis + timePeriodMillis);

                var endParts = d.tachoeventend.split(/:/);
                var timeEndPeriodMillis = (parseInt(endParts[0], 10) * 60 * 60 * 1000) +
                  (parseInt(endParts[1], 10) * 60 * 1000);
                d.tachoeventend = new Date();
                d.tachoeventend.setTime(todayMillis + timeEndPeriodMillis);
                d.tachoeventend.setTime(todayMillis + timeEndPeriodMillis);

                var hoursStringArray = d.tachoeventduration.split(':');
                var min = 0;
                min += Number(hoursStringArray[0] * 60);
                min = min + Number(hoursStringArray[1]);
                d.tachoeventduration = min / 60;

              });
              var start = moment().startOf('day');
              var end = moment(scope.chartInitialData[0].tachoeventbegin);
              var durationOfBeginPause = end.diff(start, 'minutes') / 60;

              var endOfDay = moment().endOf('day');
              var beggingOfEnd = moment(scope.chartInitialData[scope.chartInitialData.length - 1].tachoeventend);
              var durationOfEndPause = endOfDay.diff(beggingOfEnd, 'minutes') / 60;
              //console.log('start duration' + duration);

              scope.chartInitialData.unshift({
                tachoeventbegin: start.toDate(),
                tachoeventend: end.toDate(),
                tachoeventduration: durationOfBeginPause,
                driverworkinstatevalue: 0,
                driver1workingstate: $translate.instant('dashBoard.fleetManagement.tachoEventDetail.graphicsTab.pasueLabel')
              });
              scope.chartInitialData.push({
                tachoeventbegin: beggingOfEnd.toDate(),
                tachoeventend: endOfDay.toDate(),
                tachoeventduration: durationOfEndPause,
                driverworkinstatevalue: 0,
                driver1workingstate: $translate.instant('dashBoard.fleetManagement.tachoEventDetail.graphicsTab.pasueLabel')
              });

            }


            redrawChart(scope.chartInitialData);
          }

        }
      });
      var totalDelay = 500;
      var oneByOne = function (d, i) {
        return totalDelay * i / scope.chartInitialData.length;
      };


      //  var tooltip = d3.select('#tooltip');


      // Define the div for the tooltipl
      var tooltip = d3.select(element[0]).append('div')
        .attr('class', 'tooltip')
        .style('opacity', 0);

      var svg = d3.select(element[0]).append('svg')
        .attr('class', 'chart')
        .attr('width', width)
        .attr('height', height)
        .append('g')
        .attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')');

      function getWorkStateColor(state) {
        switch (state) {
          case 0:
            //return 'black';
            return 'black';
          case 1:
            //return 'blue';
            return '#2e75bf';
          case 2:
            //return 'gray';
            return '#c9c9c9';
          case 3:
            //return 'red';
            return '#ef4136';
        }
      }


      function showTip(x) {
        tooltip.transition()
          .duration(200)
          .style('opacity', 100);
        tooltip.html(x.driver1workingstate + ' : ' + commonTrackService.getTimeStringFromMinutes(x.tachoeventduration * 60, '00h 00m')).style({
          left: (d3.event.offsetX) + 'px',
          top: (d3.event.offsetY - 40) + 'px',
          background: getWorkStateColor(x.driverworkinstatevalue),
          color: '#fff',
          padding: '8px',
          transition: 'all 0.5s',
          'font-size': '11pt'
        });
      }


      function hideTip() {
        tooltip.transition()
          .duration(500)
          .style('opacity', 0);
      }

      function getDurationHour(dataObj) {
        var diffMinutes = (dataObj.tachoeventend.getTime() - dataObj.tachoeventbegin.getTime()) / (1000 * 60).toFixed(0);
        return diffMinutes / 60;
      }

      scope.$on('$destroy', function () {
          tachoDetailWidgtEvet();
        }
      );

      function drawChartLine() {
        setChartParameters(initialData);
        svg.append('g')
          .attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')');

        updateChartData(initialData);

        svg.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0, ' + (height - margin.top - margin.bottom) + ')')
          .call(xAxis);


      }

      function getYAxisHeight(workingStateValue) {
        switch (workingStateValue) {
          case 0:
            return 1.5;
          case 1:
            return 2.5;
          case 2:
            return 3.5;
          case 3:
            return 5;
        }
      }

      function updateChartData(dataList) {
        svg.selectAll('rect').remove();

        svg.selectAll('.chart')
          .data(dataList)
          .enter().append('rect')
          .attr('class', 'bar')
          .attr('x', function (d) {
            return xScale(d.tachoeventbegin);
          })
          .attr('y', function (d) {
            return height - margin.top - margin.bottom - (height - margin.top - margin.bottom - yScale(getYAxisHeight(d.driverworkinstatevalue)));
          }).on('mouseenter', showTip)
          .on('mouseleave', hideTip)
          .attr('width', function (d) {

            // calculate width :?  ( completed untill step 5 )
            /**
             Widh Calculation formula
             1. calculate 1 unit width based on total width
             2. TotalWidth / total unit ==  800 /25 which is equal to 32
             3.  calculate tachoeventduration hours : from date object get time milliseconds convert to minutes than hours ,
             4.  1 unit width multiply by  calulated duaraion hour : width for particular section ( relative to the        whole section)
             5.  width for particlualr section - padding ( which is currently 2 px)
             6.  for every bar width needs to be subracted from the previous bar wdth
             7 .  total width - previous bar widths - current bar width :  exact width of the current bar.
             **/

            var durationHours = getDurationHour(d);
            //console.log('duration hours -' + durationHours);

            var testCal = 0;
            // subtract duration from  begginHours to remove previous bar width ;
            //var paddingWidth = paddingWidthDiffernce * durationHours;
            testCal = ((width / 25 ) * durationHours) + (29 / 100) * durationHours;
            //console.log('Final calculation -' + testCal);
            return testCal;
          })
          .attr('height', function (d) {
            return height - margin.top - margin.bottom - yScale(getYAxisHeight(d.driverworkinstatevalue));
          })
          .transition()
          .duration(1500)
          .delay(oneByOne)
          .ease('elastic')
          .style('fill', function (d) {
            return getWorkStateColor(d.driverworkinstatevalue);

          });
      }

      function setChartParameters(dataList) {
        // define x axix time scale . initialize it with begin time from data .
        xScale = d3.time.scale()
          .domain(d3.extent(dataList, function (d) {
            return d.tachoeventbegin;
          }))
          .nice(d3.time.day, 1)
          .rangeRound([0, width - margin.left - margin.right]);

        yScale = d3.scale.linear()
          .domain([0, 5])
          .range([height - margin.top - margin.bottom, 0]);

        xAxis = d3.svg.axis()
          .scale(xScale)
          .orient('bottom')
          .ticks(d3.time.hours, 1)
          .tickFormat(d3.time.format('%H'))
          .tickSize(0)
          .tickPadding(4);

      }

      function redrawChart(dataList) {
        setChartParameters(dataList);
        updateChartData(dataList);
      }

      drawChartLine();
    }
  };
});



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/tachoEventGraphicD3Directive.js